import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    title: "Esta página no existe",
    description: "El evento que buscas puede haber terminado, cambiado de URL o simplemente no está aquí.",
    explore: "Explorar eventos",
    home: "Volver al inicio",
  },
  en: {
    title: "This page doesn't exist",
    description: "The event you're looking for may have ended, moved to a new URL, or simply isn't here.",
    explore: "Explore events",
    home: "Back to home",
  },
});
